import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import PropTypes from 'prop-types';
import '../style/style.css';

export default function ServicesCard({
  title, description, image, evkey,
}) {
  return (
    <Card>
      <Accordion.Toggle as={Card.Header} eventKey={evkey}>
        {title}
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={evkey}>
        <Card.Body className="service-row">
          <div className="service-image">
            <img src={`${process.env.REACT_APP_API_URI}/api/image/${image}`} width="60%" height="60%" alt="novadinamica" />
          </div>
          <div className="service-description">{description}</div>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}

ServicesCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  evkey: PropTypes.string.isRequired,
};
